/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type TopBar_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_viewer" | "CartNav_viewer" | "Likes_viewer" | "Notifications_viewer" | "Notifications_initialViewer" | "SearchBar_viewer">;
    readonly " $refType": "TopBar_viewer";
};
export type TopBar_viewer$data = TopBar_viewer;
export type TopBar_viewer$key = {
    readonly " $data"?: TopBar_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TopBar_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "hasSessionCountryCode"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopBar_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountNav_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CartNav_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Likes_viewer"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "hasSessionCountryCode",
                    "variableName": "hasSessionCountryCode"
                }
            ],
            "kind": "FragmentSpread",
            "name": "Notifications_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Notifications_initialViewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SearchBar_viewer"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '3c3f9dcfa0255dd71b03af15f4fa367c';
export default node;
